import React from 'react';
import { Form, Link, Localize, SocialButton } from '@planity/components';
import { useFormHooks } from '../useFormHooks';
import { RESET_MACHINE, SIGN_IN_WITH_GOOGLE } from '../../auth_actions';
export const SignUpWithGoogle = () => {
	const { state, dispatch, formValues } = useFormHooks();
	const { pending, children } = formValues;

	return (
		<Form>
			{children}
			<p>
				<Localize text={'auth.texts.useGoogleAuth'} />
			</p>
			<SocialButton
				css={[css.button, css.socialButton]}
				isAlone
				isDisabled={pending}
				provider={'google'}
				onPress={() => dispatch({ type: SIGN_IN_WITH_GOOGLE })}
			/>
			<div css={css.bottomLink}>
				<Link
					localizedText={`auth.form.links.BACK_TO_SIGN_IN`}
					onPress={() => dispatch({ type: RESET_MACHINE })}
				/>
			</div>
		</Form>
	);
};
const css = {
	button: {
		width: '100%',
		marginBottom: 18,
		marginTop: 12
	},
	socialButton: {
		flex: 1,
		marginBottom: 6
	},
	bottomLink: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		alignContent: 'center',
		fontSize: 16,
		lineHeight: 1.13
	}
};
